// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-diagram-tooltip-row-vertical-space {
    margin-top: 0.25rem;
}

.network-diagram-tooltip-battery-font {
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/NetworkDiagramTooltip/NetworkDiagramTooltip.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".network-diagram-tooltip-row-vertical-space {\n    margin-top: 0.25rem;\n}\n\n.network-diagram-tooltip-battery-font {\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
